import { useMutation } from "@apollo/client";
import { CreateTermsConsentMutation, CreateTermsConsentMutationVariables } from "@ctypes";
import { CREATE_TERMS_CONSENT } from "@graphql";

export const useCreateTermsConsent = () => {
  return useMutation<CreateTermsConsentMutation, CreateTermsConsentMutationVariables>(
    CREATE_TERMS_CONSENT,
  );
};
